var defaultProps = {
  divider: true,
  horizontalContentAlignment: 'center'
};
var getCloseButtonProps = function getCloseButtonProps() {
  return {
    variant: 'icon',
    size: 's',
    hierarchy: 'tertiary',
    leadingIcon: 'fill.symbol.close',
    ms: '8'
  };
};
var getHeaderContainerProps = function getHeaderContainerProps() {
  return {
    p: '16',
    display: 'flex',
    justifyContent: 'space-between'
  };
};
var getContainerBoxProps = function getContainerBoxProps() {
  return {
    position: 'sticky',
    top: '0',
    backgroundColor: 'base.surface',
    zIndex: 1
  };
};

export { defaultProps, getCloseButtonProps, getContainerBoxProps, getHeaderContainerProps };
//# sourceMappingURL=SheetHeader.mappers.js.map
